import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import { api } from "@/lib/api";
import { SectionTitle } from "@/components/news/SectionTitle";
import { MagazineIssueList } from "@/components/magazine/MagazineIssueList";
import { MagazineReader } from "@/components/magazine/MagazineReader";

export default function MagazinePage() {
  const [items, setItems] = useState([]);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    api.get("/magazines").then((r) => { setItems(r.data); setCurrent(r.data[0] || null); }).catch((error) => console.error("Magazines error:", error));
  }, []);

  return (
    <div className="space-y-8" data-testid="magazine-page">
      <div className="bg-[#111827] text-white p-8 md:p-12 relative overflow-hidden">
        <BookOpen size={160} className="absolute -right-6 -bottom-10 text-red-600/20" />
        <span className="badge-cat">Liseuse</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-black mt-3">Chronique Magazine</h1>
        <p className="text-zinc-400 mt-3 max-w-xl">Feuilletez en ligne nos éditions numériques : dossiers, enquêtes et portraits, au format PDF.</p>
      </div>
      <div className="grid lg:grid-cols-4 gap-8">
        <aside>
          <SectionTitle>Éditions</SectionTitle>
          <MagazineIssueList items={items} current={current} onSelect={setCurrent} />
        </aside>
        <div className="lg:col-span-3">{current && <MagazineReader magazine={current} />}</div>
      </div>
    </div>
  );
}
